module.exports = __webpack_public_path__ + "img/dacia-logo.svg";